import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { GassClaims } from 'src/app/auth/gass-claims';
import { IdentityService } from 'src/app/auth/identity.service';
import { StatiPredefiniti } from 'src/app/shared/models/stati-predefiniti';

@Component({
  selector: 'app-visualizza-toolbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-toolbar>
      <div class="p-toolbar-group-left">
        @if (!editMode()) {
          <button pButton type="button" title="Stampa etichetta" icon="fas fa-tag" (click)="printLabel.emit()" [disabled]="disableToolbarButton('tag')" ></button>
        }
        @if (!isLocked()) {
          <ng-container *hasClaim="GassClaims.DocModifica" >
          @if (!editMode()) {
            <button pButton type="button" title="Modifica dati" icon="fas fa-fw fa-edit" (click)="edit.emit()" [disabled]="disableToolbarButton('edit')"></button>
          }
          @else {
            <button pButton type="button" title="Salva modifiche" icon="fas fa-fw fa-save" (click)="saveEdit.emit()" [disabled]="disableToolbarButton('save')"></button>
            <button pButton type="button" title="Annulla modifiche" icon="fas fa-fw fa-undo" (click)="undoEdit.emit()" class="p-button-secondary" [disabled]="disableToolbarButton('undo')"></button>
          }
            <i class="fas fa-fw fa-ellipsis-v"></i>
          </ng-container>
        }
        @else if (!editMode()) {
          <button *hasClaim="GassClaims.DocModifica" pButton type="button" title="Modifica note" icon="fas fa-fw fa-quote-right" (click)="editNote.emit()" [disabled]="disableToolbarButton('note')"></button>
          <i class="fas fa-fw fa-ellipsis-v"></i>
        }

        @if (!editMode()) {
          <ng-container *hasClaim="GassClaims.DocModifica">
            <button pButton type="button" title="In archivio" icon="fas fa-fw fa-archive" (click)="atti.emit()" [disabled]="disableToolbarButton('archive')" ></button>
            <button pButton type="button" title="Modifica stato" icon="fas fa-fw fa-exchange-alt" (click)="changeState.emit()" [disabled]="disableToolbarButton('state')"></button>
            <button pButton type="button" title="Sposta fascicolo" icon="fas fa-fw fa-map-marker-alt" (click)="moveFascicolo.emit()"  [disabled]="disableToolbarButton('folder')"></button>
            <i class="fas fa-fw fa-ellipsis-v"></i>
            <button pButton type="button" title="Crea partenza" icon="fas fa-fw fa-reply" (click)="reply.emit()" [disabled]="disableToolbarButton('reply')"></button>
            <button pButton type="button" title="Crea copia di lavoro" icon="fas fa-fw fa-copy" (click)="createCopy.emit()" [disabled]="disableToolbarButton('copy')"></button>
            <button pButton type="button" title="Crea riproduzione" icon="fas fa-fw fa-registered" (click)="riproduzione.emit()" [disabled]="disableToolbarButton('registered')"></button>
            <button pButton type="button" title="Scarica Ricevuta di Trasmissione" icon="fas fa-fw fa-receipt" (click)="printReceipt.emit()" [disabled]="disableToolbarButton('receipt')"></button>
            <button pButton type="button" title="Aggiungi riferimento" icon="fas fa-fw fa-share-alt" (click)="link.emit()" [disabled]="disableToolbarButton('reference')"></button>
            <button pButton type="button" title="Trasmetti Allegati" icon="fas fa-fw fa-share-square" (click)="transmit.emit()" [disabled]="disableToolbarButton('attachment')"></button>
            <i class="fas fa-fw fa-ellipsis-v"></i>
            <button pButton type="button" title="Eleva/Declassifica/Proroga" icon="fas fa-fw fa-file-download" (click)="declassify.emit()" [disabled]="disableToolbarButton('download')"></button>
            <button pButton type="button" title="Scarica XML Documento Amministrativo" icon="fas fa-fw fa-file-code" (click)="downloadAdminXml.emit()" [disabled]="disableToolbarButton('admin-xml')"></button>
            <button pButton type="button" title="Versa agli archivi di stato" icon="fas fa-fw fa-landmark" (click)="sendToStateArchive.emit()" [disabled]="disableToolbarButton('landmark')"></button>
            <button pButton type="button" title="Acquisizione ex art. 42 comma 8 124/2007" icon="fas fa-fw fa-file-export" (click)="temporarySend.emit()" [disabled]="disableToolbarButton('export')"></button>
          </ng-container>

          <ng-container *hasClaim="GassClaims.DocDistruzione">
            <button pButton type="button" title="Annulla" icon="fas fa-fw fa-ban" class="p-button-danger" (click)="revoke.emit()" [disabled]="disableToolbarButton('cancel')"></button>
            <button pButton type="button" title="Distruggi" icon="fas fa-fw fa-trash" class="p-button-danger" (click)="onDestroyClick()" [disabled]="disableToolbarButton('trash')"></button>
          </ng-container>
        }
      </div>
      <div class="p-toolbar-group-right">
        <ng-container *hasClaim="GassClaims.DocAnnullaOperazione">
          <button pButton type="button" [title]="lastOperationLabel()" icon="fas fa-fw fa-undo" (click)="undoLastOperation()" [disabled]="disableToolbarButton('undo-ultima-operazione')" class="p-button-danger"></button>
          <i class="fas fa-fw fa-ellipsis-v"></i>
        </ng-container>

        @if (isLocked()) {
          <button *hasClaim="GassClaims.DocRiapertura" pButton type="button" title="Sblocca" icon="fas fa-fw fa-unlock" (click)="unlock.emit()" [disabled]="disableToolbarButton('unlock')"></button>
        }
        @else {
          <button *hasClaim="GassClaims.DocModifica" pButton type="button" title="Blocca" icon="fas fa-fw fa-lock" (click)="lock.emit()" [disabled]="disableToolbarButton('lock')"></button>
        }
      </div>
    </p-toolbar>
  `,
  styles: [
    `button { margin-right: .25em; }`
  ]
})

export class VisualizzaToolbarComponent {
  showReply = input<boolean>(false);
  isLocked = input<boolean>(false);
  editMode = input<boolean>(false);
  arrivo = input<boolean>(false);
  isDocInvalid = input<boolean | null>(null);
  isRiproduzione = input<boolean | undefined>();

  isDocDestroyed = input<boolean>(false);

  operationsCanUndo = input<number[] | null>();

  atti = output();
  edit = output();
  editNote = output();
  saveEdit = output();
  undoEdit = output();
  changeState = output();
  reply = output();
  createCopy = output();
  link = output();
  lock = output();
  unlock = output();
  revoke = output();
  destroy = output();
  declassify = output();
  sendToStateArchive = output();
  temporarySend = output();
  riproduzione = output();
  moveFascicolo = output();
  transmit = output();
  printLabel = output();
  printReceipt = output();
  downloadAdminXml = output();

  undoOperation = output<number>();


  public GassClaims = GassClaims;
  private readonly confirmationService = inject(ConfirmationService);
  private readonly indentityService = inject(IdentityService);


  public lastOperationLabel = computed<string>(() => {

    let label = 'Annulla Ultima Operazione';

    if (this.isDocDestroyed()) {
      label = 'Annulla Distruzione';
    } else {
      if (this.operationsCanUndo()?.includes(StatiPredefiniti.Declassificato)) {
        label = 'Annulla Ultima Declassifica';
      }
    }

    return label;
  });

  public undoLastOperation(): void {
    const operationToUndo = (this.isDocDestroyed()) ? StatiPredefiniti.Distrutto : StatiPredefiniti.Declassificato;

    if (this.indentityService.hasClaim(GassClaims.DocAnnullaOperazione))
      this.undoOperation.emit(operationToUndo);
  }

  public disableToolbarButton(button: string): boolean {
    let result = true;

    switch (button) {
      case 'save':
        result = this.isDocDestroyed() || !!this.isDocInvalid();
        break;
      case 'reply':
        result = this.isDocDestroyed() || !this.showReply();
        break;
      case 'registered':
        result = this.isDocDestroyed() || !!this.isRiproduzione();
        break;
      case 'receipt':
        result = this.isDocDestroyed() || this.arrivo();
        break;
      case 'folder':
        result = (this.isDocDestroyed() || !this.indentityService.hasClaim(GassClaims.DocSpostamento));
        break;
      case 'undo-ultima-operazione':
        result = (
          !(this.isDocDestroyed() && this.operationsCanUndo()?.includes(StatiPredefiniti.Distrutto)) &&
          !(!this.isDocDestroyed() && this.operationsCanUndo()?.includes(StatiPredefiniti.Declassificato))
        ) || !this.indentityService.hasClaim(GassClaims.DocAnnullaOperazione);
        break;
      default:
        result = this.isDocDestroyed();
        break;
    }
    return result;
  }

  onDestroyClick(): void {
    this.confirmationService.confirm({
      header: 'Distruzione documento',
      icon: 'fas fa-fw fa-trash',
      message: `La distruzione di un documento provocherà la cancellazione di tutti gli allegati e bloccherà ogni modifica.
      <p>Sei sicuro di voler distruggere il documento?</p>`,
      accept: () => {
        this.destroy.emit();
      }
    });
  }
}
